class ServicesPanel extends window.TabbedSlideOutPanel {
  get openTriggerSelector() {
    return '[data-services-panel-open]';
  }

  getOpenOptionsFromTrigger(trigger) {
    return {
      tabId: trigger.getAttribute('data-services-panel-open') || undefined,
    };
  }

  onConnected() {
    super.onConnected();
    this.querySelector('[data-services-chat]')?.addEventListener('click', () => this.openChat());
  }

  openChat() {
    this.close();

    const openGorgias = () => {
      if (window.GorgiasChat) {
        window.GorgiasChat.open();
        return;
      }

      document.querySelector('#chat-button')?.click();
    };

    setTimeout(openGorgias, 300);
  }
}

if (!customElements.get('services-panel')) {
  customElements.define('services-panel', ServicesPanel);
}
